import React from 'react';
import { upsideStats } from '../../mock/content';
import CountUp from './CountUp';
import Reveal from './Reveal';

const Upside = () => {
  return (
    <section
      className="relative py-24 md:py-28 overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(135deg, rgba(26,32,53,0.78) 0%, rgba(52,71,103,0.72) 100%), url('https://images.unsplash.com/photo-1522069365959-25716fb5001a?w=1920&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><circle cx='60' cy='60' r='1' fill='%23ffffff'/></svg>\")",
        }}
      />
      <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue-light text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            The upside
          </p>
          <h2 className="text-white font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            What a lead generation line actually gives you
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {upsideStats.map((s, i) => (
            <Reveal
              key={s.label}
              delay={i * 110}
              className="rounded-2xl bg-white/[0.06] backdrop-blur border border-white/10 p-7 hover:bg-white/[0.09] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="text-brand-blue-light text-[38px] sm:text-[44px] font-black leading-none tracking-tight">
                <CountUp value={s.value} />
              </div>
              <p className="mt-4 text-slate-300 text-[13.5px] leading-[1.6] font-medium">
                {s.label}
              </p>
            </Reveal>
          ))}
        </div>

        <div className="mt-20 text-center max-w-[820px] mx-auto">
          <p className="text-white text-[26px] sm:text-[32px] font-bold leading-[1.4]">
            “We make our partners look brilliant in front of their clients.”
          </p>
          <p className="mt-4 text-slate-400 text-[15px]">
            That is the whole job. Everything we build serves it.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Upside;
